export default {"src":"/_next/static/media/call-phone-icon.69d730fc.svg","height":1600,"width":1600};